import { Injectable } from '@angular/core';
import {
    ResourceAction,
    ResourceCRUD,
    ResourceMethod,
    ResourceParams
} from 'ng2-resource-rest';
import { RequestMethod } from '@angular/http';

interface IContactInput {
    title   : string;
    message : string;
    contact : string;
}

export interface IContact  {
    id   : number;
    name : string;
}

@Injectable()
@ResourceParams({
    url: '/api/contact'
})
export class Contact extends ResourceCRUD<IContactInput, void, void> {
  @ResourceAction({
    path: '/send',
    method: RequestMethod.Post
  })
  public send: ResourceMethod<IContactInput, void>;
  @ResourceAction({
    path: '/order',
    method: RequestMethod.Post
  })
  public order: ResourceMethod<any, void>;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/model/contact.ts